import {LINKS} from '@/const/link';
import {PATHS} from '@/const/paths';
import {SERVICES} from '@/const/services';

const PREFIX = `${SERVICES.STATIC_URL}/s/web/account/`;

export const MENU_ICONS = {
  OTC: PREFIX + 'otc.svg',
  CREDIT_CARD: PREFIX + 'credit-card.svg',
  ALL_STAR: PREFIX + 'all_star.svg',
  CONTRACT: PREFIX + 'contract.svg',
  PREMIUM: PREFIX + 'premium.svg',
  SIMULATED: PREFIX + 'simulated.svg',
  SPOT: PREFIX + 'spot.svg',
  WELCOME: PREFIX + 'welcome.svg',
  ZERO_FEES: PREFIX + 'zerofees.svg',
  REFERRAL: PREFIX + 'referral.svg',
  INVESTMENT: PREFIX + 'investment.svg',
  CONVERSION: PREFIX + 'conver.svg',
  NEW: PREFIX + 'new.svg',
  EARN: PREFIX + 'earn.svg',
  LAUNCHPOOL: PREFIX + 'lanuchpool_icon_v1.svg',
  LAUNCHPAD: PREFIX + 'launchpad.svg',
};

const PREFIX2 = `${SERVICES.STATIC_URL}/s/home/side-menu/`;

export const MENU_ICONS2 = {
  BUY_CRYPTO: PREFIX2 + 'buy-crypto.png',
  CONTRACT: PREFIX2 + 'contract.png',
  EARN: PREFIX2 + 'earn.png',
  LANGUAGE: PREFIX2 + 'language.png',
  LEARN: PREFIX2 + 'learn.png',
  MARKETS: PREFIX2 + 'markets.png',
  PROMOTION: PREFIX2 + 'promotion.png',
  SIGNOUT: PREFIX2 + 'signout.png',
  SPOT: PREFIX2 + 'spot.png',
  WEB3: 'https://img.phemex.com/v1/3e7ad4ba/header-web3-h5-icon.png',
};

export const showHeaderList = [
  PATHS.HOME.pathname,
  PATHS.ABOUT.pathname,
  PATHS.ABOUT_BRAND_STYLE_GUIDE.pathname,
  PATHS.ABOUT_AMBASSADOR_KEVIN_DE_BRUYNE.pathname,
  PATHS.ABOUT_AMBASSADOR_KEVIN_DE_BRUYNE_AUDIT.pathname,
  PATHS.BUY_CRYPTO.pathname,
  PATHS.BUY_CRYPTO_PLACE_ORDER.pathname,
  PATHS.BUY_CRYPTO_HOW_TO_BUY.pathname,
  PATHS.DOWNLOAD.pathname,
  PATHS.CONTRACT_WARS.pathname,
  PATHS.EARN.pathname,
  PATHS.EARN_HOME.pathname,
  PATHS.BIG_CLIENT_DASHBOARD.pathname,
  PATHS.TRADING_DEPOSIT_BONUS.pathname,
  PATHS.DEPOSIT_DAZZLE_MDX.pathname,
  PATHS.REGISTER_VERIFIED.pathname,
  PATHS.OTC_LEGEND_TRADING.pathname,
  PATHS.MO_TRADE_COMPETITION.pathname,
  PATHS.BITSHIN_TRADE_COMPETITION.pathname,
  PATHS.CRYPTO_CONVERTER.pathname,
  PATHS.CRYPTO_TRADING_COMPETITION_1_ON_1.pathname,
  PATHS.BONUS_CENTER.pathname,
  PATHS.KYC_MYSTERY_BOX.pathname,
  PATHS.STUDENT_FOUNDATION.pathname,
  PATHS.CRYPTO_TRADING_REBATES.pathname,
  PATHS.LAUNCHPAD.pathname,
  PATHS.CRYPTO_COIN_FLIP.pathname,
  PATHS.PREMIUM_ARCHIVED.pathname,
  PATHS.REGISTER_VT1.pathname,
  PATHS.BUY_CRYPTO_BUY_ETHEREUM.pathname,
  PATHS.BUY_CRYPTO_BUY_XTZ.pathname,
  PATHS.BUY_CRYPTO_BUY_ALGO.pathname,
  PATHS.BUY_CRYPTO_BUY_AVAX.pathname,
  PATHS.BUY_CRYPTO_BUY_LTC.pathname,
  PATHS.BUY_CRYPTO_BUY_XLM.pathname,
  PATHS.BUY_CRYPTO_BUY_USDC.pathname,
  PATHS.BUY_CRYPTO_BUY_SAND.pathname,
  PATHS.BUY_CRYPTO_BUY_ZEC.pathname,
  PATHS.BUY_CRYPTO_BUY_MATIC.pathname,
  PATHS.BUY_CRYPTO_BUY_TRX.pathname,
  PATHS.BUY_CRYPTO_BUY_MANA.pathname,
  PATHS.BUY_CRYPTO_BUY_LRC.pathname,
  PATHS.BUY_CRYPTO_BUY_SOL.pathname,
  PATHS.BUY_CRYPTO_BUY_DENT.pathname,
  PATHS.BUY_CRYPTO_BUY_ADA.pathname,
  PATHS.BUY_CRYPTO_BUY_DOT.pathname,
  PATHS.BUY_CRYPTO_BUY_BCH.pathname,
  PATHS.BUY_CRYPTO_BUY_BTC.pathname,
  PATHS.BUY_CRYPTO_BUY_XRP.pathname,
  PATHS.BUY_CRYPTO_BUY_SHIB.pathname,
  PATHS.BUY_CRYPTO_BUY_DOGE.pathname,
  PATHS.PREDICT_ETH_PRICE.pathname,
  PATHS.COPY_TRADING_LIST.pathname,
  PATHS.COPY_TRADING_DRAW.pathname,
  PATHS.BECOME_A_TRADER.pathname,
  PATHS.KOL_LANDING.pathname,
  PATHS.KOL_LANDING_ACTIVITY.pathname,
  PATHS.MARGIN_TRADING_COMPETITION.pathname,
  PATHS.VIP_PROGRAM.pathname,
  PATHS.SWAP_ETH.pathname,
  PATHS.PT_ARENA_5.pathname,
  PATHS.ACCOUNT_INVITE_FRIENDS.pathname,
  PATHS.ACCOUNT_INVITE_FRIENDS_ENTRY.pathname,
  PATHS.WORLD_CUP.pathname,
  PATHS.DOWNLOAD_IOS_PRO.pathname,
  PATHS.P2P_MERCHANT_APPLY.pathname,
  PATHS.FIAT_BUY_CRYPTO_PLACE_ORDER.pathname,
  PATHS.FIAT_BUY_CRYPTO_BUY_PAYMENT_METHOD.pathname,
  PATHS.FIAT_BUY_CRYPTO_BUY_CONFIRM.pathname,
  PATHS.FIAT_BUY_CRYPTO_BUY_CARD.pathname,
  PATHS.FIAT_BUY_CRYPTO_BUY_RESULT.pathname,
  PATHS.FIAT_BUY_CRYPTO_SELL_CARD.pathname,
  PATHS.FIAT_BUY_CRYPTO_SELL_PAYMENT_METHOD.pathname,
  PATHS.FIAT_BUY_CRYPTO_SELL_CONFIRM.pathname,
  PATHS.FIAT_BUY_CRYPTO_SELL_RESULT.pathname,
  PATHS.FIAT_DEPOSIT.pathname,
  PATHS.FIAT_DEPOSIT_TRANSFER_INFO.pathname,
  PATHS.FIAT_WITHDRAW.pathname,
  PATHS.FIAT_WITHDRAW_ORDER_CONFIRM.pathname,
  PATHS.LEGEND_TRADING_SYNC_KYC.pathname,
  PATHS.LEGEND_TRADING_BIND_CARD.pathname,
  PATHS.FIAT_WITHDRAW_ORDER_RESULT.pathname,
  PATHS.LEGEND_TRADING_MANAGE_CARD.pathname,
  PATHS.XPT_MINING.pathname,
  PATHS.BUY_CRYPTO_CARD_PLACE_ORDER.pathname,
  PATHS.BUY_CRYPTO_CARD_PAY.pathname,
  PATHS.BUY_CRYPTO_CARD_PAYMENT.pathname,
  PATHS.BUY_CRYPTO_CARD_ORDER_SUCCESS.pathname,
  PATHS.BUY_CRYPTO_CARD_ORDER_FAIL.pathname,
  PATHS.BUY_CRYPTO_CARD_ORDER_CONFIRM.pathname,
  PATHS.XPT_AIRDROP.pathname,
  PATHS.BUY_CRYPTO_CARD_SELL_CONFIRM.pathname,
  PATHS.BUY_CRYPTO_CARD_SELL_RESULT.pathname,
  PATHS.STRATEGY_SQUARE.pathname,
  PATHS.STRATEGY_DETAIL.pathname,
  PATHS.XPT_AIRDROP.pathname,
  PATHS.CEX_AIRDROP.pathname,
  PATHS.DEX_AIRDROP.pathname,
  PATHS.FTX_AIRDROP.pathname,
  PATHS.FUTURE_GRIDS_TRADING_CONTEST.pathname,
  PATHS.CONTRACT_LEADERBOARD.pathname,
  PATHS.CONTRACT_LEADERBOARD_PROFILE.pathname,
  PATHS.CONTRACT_LEADERBOARD_FOLLOW_LIT.pathname,
];

const navPathnameRelation = {
  BuyCrypto: [
    {pathname: PATHS.BUY_CRYPTO_BUY_ALGO.pathname, query: null},
    {pathname: PATHS.BUY_CRYPTO.pathname, query: null},
    {pathname: PATHS.P2P_HOME.pathname, query: null},
    {pathname: PATHS.BUY_CRYPTO_HOW_TO_BUY.pathname, query: null},
    {pathname: '/buy-crypto/card', query: null},
    {pathname: '/fiat/buy-crypto', query: null},
    {pathname: PATHS.FIAT_DEPOSIT.pathname, query: null},
    {pathname: PATHS.FIAT_WITHDRAW.pathname, query: null},
    {pathname: PATHS.FIAT_WITHDRAW_ORDER_CONFIRM.pathname, query: null},
    {pathname: PATHS.FIAT_B2C_URL_PAYMENT.pathname, query: null},
    {pathname: PATHS.FIAT_B2C_PAYMENT_RESULT.pathname, query: null},
    {pathname: PATHS.FIAT_BUY_CRYPTO_SELL_CARD.pathname, query: null},
    {pathname: PATHS.FIAT_BUY_CRYPTO_SELL_CONFIRM.pathname, query: null},
    {pathname: PATHS.FIAT_BUY_CRYPTO_SELL_PAYMENT_METHOD.pathname, query: null},
    {pathname: PATHS.FIAT_BUY_CRYPTO_SELL_RESULT.pathname, query: null},
    {pathname: PATHS.FIAT_DEPOSIT_TRANSFER_INFO.pathname, query: null},
    {pathname: PATHS.FIAT_WITHDRAW_ORDER_RESULT.pathname, query: null},
    {pathname: PATHS.OTC_LEGEND_TRADING.pathname, query: null},
    {pathname: PATHS.OTC_LEGEND_TRADING_HISTORY.pathname, query: null},
    {pathname: PATHS.LEGEND_TRADING_BIND_CARD.pathname, query: null},
    {pathname: PATHS.LEGEND_TRADING_MANAGE_CARD.pathname, query: null},
    {pathname: PATHS.LEGEND_TRADING_SYNC_KYC.pathname, query: null},
    {pathname: PATHS.LEGEND_TRADING_WRITE_QUESTIONNAIRE.pathname, query: null},
    {pathname: PATHS.LEGEND_TRADING_BILLING_ADDRESS.pathname, query: null},
    {pathname: PATHS.LEGEND_TRADING_CARD_BINDING.pathname, query: null},
    {pathname: PATHS.LEGEND_TRADING_PAYMENT.pathname, query: null},
  ],
  Markets: [{pathname: PATHS.MARKETS.pathname, query: null}],
  Contract: [
    {pathname: LINKS.PHEMEX_CONTRACT_TRADE, query: null},
    {pathname: '/moc' + LINKS.PHEMEX_CONTRACT_TRADE, query: null},
    {pathname: LINKS.PHEMEX_CONTRACT_INVERSE_TRADE, query: null},
    {pathname: '/moc' + LINKS.PHEMEX_CONTRACT_INVERSE_TRADE, query: null},
    {pathname: PATHS.STRATEGY_SQUARE.pathname, query: {type: 'CONTRACT_GRID'}},
    {pathname: PATHS.STRATEGY_SQUARE.pathname, query: {type: 'CONTRACT_MARTIN'}},
    {pathname: '/moc' + PATHS.STRATEGY_SQUARE.pathname, query: {type: 'CONTRACT_GRID'}},
    {pathname: '/moc' + PATHS.STRATEGY_SQUARE.pathname, query: {type: 'CONTRACT_MARTIN'}},
    {pathname: PATHS.CONTRACT_INTRODUCTION.pathname, query: null},
    {pathname: PATHS.CONTRACT_PERPETUAL_CONTRACT.pathname, query: null},
    {pathname: PATHS.CONTRACT_LEVERAGE_MARGIN.pathname, query: null},
    {pathname: PATHS.CONTRACT_INDEX_PRICE.pathname, query: null},
    {pathname: PATHS.CONTRACT_MARK_PRICE.pathname, query: null},
    {pathname: PATHS.CONTRACT_INSURANCE_FUND.pathname, query: null},
    {pathname: PATHS.CONTRACT_FUNDING_HISTORY.pathname, query: null},
    {pathname: PATHS.CONTRACT_DATA_INSIGHT.pathname, query: null},
    {pathname: PATHS.CONTRACT_LEADERBOARD.pathname, query: null},
    {pathname: PATHS.COPY_TRADING_LIST.pathname, query: null},
    {pathname: PATHS.TRADER_HOME_FOLLOWER_VIEW.pathname, query: null},
    {pathname: PATHS.COPIER_DETAIL.pathname, query: null},
    {pathname: PATHS.COPY_SETTINGS.pathname, query: null},
    {pathname: PATHS.TRADER_HOME.pathname, query: null},
    {pathname: PATHS.COPY_TRADING_TRADER_SETTING.pathname, query: null},
    {pathname: PATHS.COPY_TRADING_FAQ.pathname, query: null},
    {pathname: PATHS.BECOME_A_TRADER.pathname, query: null},
    {pathname: PATHS.COPY_LEADERBOARD.pathname, query: null},
    {pathname: PATHS.COPY_TRADING_DRAW.pathname, query: null},
    {pathname: PATHS.GMX_TRADER_LIST.pathname, query: null},
    {pathname: PATHS.FUTURE_GRIDS_TRADING_CONTEST.pathname, query: null},
  ],
  Spot: [
    {pathname: LINKS.PHEMEX_SPOT_TRADE, query: null},
    {pathname: '/moc/' + LINKS.PHEMEX_SPOT_TRADE, query: null},
    {pathname: PATHS.STRATEGY_SQUARE.pathname, query: {type: 'SPOT_GRID'}},
    {pathname: '/moc' + PATHS.STRATEGY_SQUARE.pathname, query: {type: 'SPOT_GRID'}},
    {pathname: LINKS.PHEMEX_SPOT_MARGIN_TRADE, query: null},
    {pathname: '/moc/' + LINKS.PHEMEX_SPOT_MARGIN_TRADE, query: null},
    {pathname: PATHS.CRYPTO_CONVERTER.pathname, query: null},
    {pathname: PATHS.LAUNCHPAD.pathname, query: null},
    {pathname: PATHS.LAUNCHPAD_DETAIL.pathname, query: null},
    {pathname: PATHS.LAUNCHPAD_HISTORY.pathname, query: null},
  ],
  Web3: [{pathname: '/web3/', query: null}],
  Earn: [
    {pathname: PATHS.EARN_HOME.pathname, query: null},
    {pathname: PATHS.LAUNCHPOOL.pathname, query: null},
    {pathname: PATHS.PREDICT_TO_EARN.pathname, query: null},
    {pathname: PATHS.PREDICT_TO_EARN_HISTORY.pathname, query: null},
    {pathname: PATHS.PREDICT_TO_EARN_DETAIL.pathname, query: null},
  ],
  Learn: [
    {pathname: PATHS.LEARN_CRYPTO.pathname, query: null},
    {pathname: PATHS.BROKER_INDEX.pathname, query: null},
    {pathname: PATHS.STUDENT_FOUNDATION.pathname, query: null},
  ],
};

export const CommissionMode = {
  KOL: 0,
  Partner: 1,
};

export const navPathnameRelationMap = Object.keys(navPathnameRelation).reduce((p, c) => {
  navPathnameRelation[c].forEach((item) => {
    return p.set(item.pathname, [
      ...(p.has(item.pathname) ? p.get(item.pathname) : []),
      {
        ...item,
        navKey: c,
      },
    ]);
  });
  return p;
}, new Map());

export const FETURES_CATEGORY = {
  PILOT: 'pilot_contract',
  USDT: 'usdt_m_perpetual',
  COIN: 'coin_m_perpetual',
};
